module.exports = __webpack_public_path__ + "static/media/gallery-11.acf67813.JPG";